module.exports = __webpack_public_path__ + "img/cloud.ac2f6913.png";